<template>
    <div>
        <div class="table-title">
            {{ $t('enps.report.rankingPromotingTeams') }}
        </div>
        <b-table
            responsive
            borderless
            caption-top
            :fields="fields"
            id="ranking-table"
            head-variant="light"
            :items="rankingTeams"
            :busy="isLoading"
        >
            <template #cell(detractors_percent)="row">
                <div id="column-enps-detractors">
                    {{ row.item.detractors_percent !== null ? formatNumber(row.item.detractors_percent) : 0 }}%
                </div>
            </template>

            <template #cell(neutral_percent)="row">
                <div id="column-enps-neutral">
                    {{ row.item.neutral_percent !== null ? formatNumber(row.item.neutral_percent) : 0 }}%
                </div>
            </template>

            <template #cell(promoters_percent)="row">
                <div id="column-enps-promoters">
                    {{ row.item.promoters_percent !== null ? formatNumber(row.item.promoters_percent) : 0 }}%
                </div>
            </template>
        </b-table>
        <b-pagination
            v-if="pagination.total > pagination.perPage"
            size="sm"
            class="ml-2"
            aria-controls="ranking-table"
            v-model="pagination.currentPage"
            :total-rows="pagination.total"
            :per-page="pagination.perPage"
            :disabled="isLoading"
        />
    </div>
</template>
<script>
import { getEnpsByTeams } from '@/views/enps/api'
export default {
    props: {
        filters: Object,
    },
    data() {
        return {
            isLoading: false,
            rankingTeams: [],
            pagination: {
                total: 0,
                perPage: 10,
                currentPage: 1,
            },
        }
    },
    computed: {
        fields() {
            return [
                { key: 'team_name', label: this.$t('groupLevel.department') },
                {
                    key: 'detractors_percent',
                    label: this.$t('enps.report.detractors'),
                    sortable: true,
                },
                {
                    key: 'neutral_percent',
                    label: this.$t('enps.report.neutral'),
                    sortable: true,
                },
                {
                    key: 'promoters_percent',
                    label: this.$t('enps.report.promoters'),
                    sortable: true,
                },
            ]
        },
    },
    mounted() {
        this.getRankingByTeams()
    },
    watch: {
        filters() {
            this.getRankingByTeams()
        },
        'pagination.currentPage': function () {
            this.getRankingByTeams()
        },
    },
    methods: {
        getRankingByTeams() {
            this.isLoading = true
            const params = {
                enps_researches_ids: this.filters.enpsResearches,
                departments_ids: this.filters.departments,
                page: this.pagination.currentPage,
                per_page: this.pagination.perPage,
            }
            getEnpsByTeams(params)
                .then((data) => {
                    this.rankingTeams = data.data
                    this.pagination.currentPage = data.current_page
                    this.pagination.perPage = data.per_page
                    this.pagination.total = data.total
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
        formatNumber(number) {
            return parseFloat((Math.floor(number * 100) / 100).toFixed(2))
        },
    },
}
</script>
<style lang="scss" scoped>
.table-title {
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 17.5px;
    line-height: 21px;
    color: #6e6e6e;
    margin-bottom: 12px;
}
</style>
